import modalMixin from "../mixins/modal.mixin";
import formlMixin from "../mixins/form.mixin";
export default class MixinFactory {
    // #region Properties
    get modal() {
        return modalMixin;
    }
    get form() {
        return formlMixin;
    }
}
